import axios from "axios";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import logo from "./assets/faceit_logo.png";
import Modal from "./Modal";
import "./styles/App.scss";
import "./styles/Modal.scss";
import { generateUrl } from "./utils/generateUrl";

import { useT } from "./router/Router";
import { hubIdStorage, verifyUser } from "./utils/user";

const App = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const [modalOpened, setModalOpened] = useState(false);
    const t = useT();

    useEffect(() => {
        const updateSteamConnected = async () => {
            const user = await verifyUser();

            if (user && user?.steam_connected) return navigate("/review");

            const urlParams = new URLSearchParams(window.location.search);

            const inviteCode = urlParams.get("invitation_code");

            if (inviteCode)
                await axios
                    .post(generateUrl(`customer/create/authenticated`), {
                        invitation_code: inviteCode,
                    })
                    .then((res) => {
                        localStorage.setItem(hubIdStorage, res.data?.hub_id);

                        navigate("/review");
                    })
                    .catch(() => false);

            if (user && !user.steam_connected) setModalOpened(true);

            if (location.search !== "?review-succeed") return;

            if (user && !user?.steam_connected)
                await axios
                    .put(
                        generateUrl(`customer/update/by_hub_id/${user.hub_id}`),
                        {
                            steam_connected: true,
                        }
                    )
                    .then(() => navigate("/review"))
                    .catch(() => false);
        };

        updateSteamConnected();
    }, []);

    return (
        <div className="App">
            <div className="animated-bg-wrapper">
                <div className="animated-bg"></div>
            </div>
            <header>
                <img src={logo} className="logo" />
            </header>
            <div className="App-content">
                <p className="title">{t("welcome_message")}</p>
                <p className="description">{t("welcome_text")}</p>
                <button onClick={() => setModalOpened(true)}>
                    {t("welcome_button")}
                </button>
            </div>

            <Modal
                opened={modalOpened}
                closeModal={() => setModalOpened(false)}
            />
        </div>
    );
};

export default App;
